<template>
  <div class="navigation">
    <router-link to="/">
      <div class="logo-div">
        <img
          class="nav-logo"
          src="../assets/MoreAndMore-Logo_Navbar_White.png"
        />
      </div>
    </router-link>
    <div>
      <h1>
        <!--  Digital Card Decks -->
        <span class="deck-name" v-if="gameInSession">
          {{ gameInSession }}
        </span>
      </h1>
    </div>

    <div class="right-side-links">
      <!-- <div id="links-open-in-tab" v-if="gameInSession">
        <router-link :to="{ name: 'ExtendedResources' }" target="_blank"
          >Extended Resources
        </router-link>
        <router-link to="/About" target="_blank">About</router-link>
      </div>
      <div id="links-open-in-self" v-if="!gameInSession">
        <router-link :to="{ name: 'ExtendedResources' }"
          >Extended Resources
        </router-link>
        <router-link to="/About">About</router-link>
      </div> -->
      <a href="https://www.moreandmore.world/" target="_blank">
        About<span class="about-long-text"> More&More</span>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Navigation",
  data() {
    return {};
  },
  computed: {
    gameInSession() {
      return this.$route.params.deckId;
    },
    isWhatIf() {
      return this.$route.params.deckId === `What If?`;
    },
  },
  methods: {},
};
</script>
<style scoped>
.navigation {
  position: fixed;
  z-index: 2000;
  top: 0;
  width: 100vw;
  height: var(--var-nav-height);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  background-color: black;
  color: white;
  box-sizing: border-box;
  text-transform: uppercase;
  padding-top: 0.2rem;
}

.nav-logo {
  height: 5rem;
  position: fixed;
  left: 1rem;
  top: 0.4rem;
  margin: 0;
}

.navigation h1 {
  margin: 0;
  padding: 0;
  display: inline-block;
  font-size: 1.45rem;
  line-height: 1;
  color: var(--var-IIF-yellow);
}
.navigation h1,
.navigation h1 a {
  text-decoration: none;
  text-transform: uppercase;
}
.navigation h1 .deck-name {
  margin: 0 0 0 10rem;
  display: block;
  font-family: "Univers-black", Arial, Helvetica, sans-serif;
  font-size: 1.6rem;
  line-height: 1.1;
  color: white;
}

.navigation .created-by {
  display: inline-block;
  font-family: Arial, Helvetica, sans-serif;
  color: var(--var-IIF-dark-teal);
  text-transform: none;
  margin-left: 1rem;
  font-size: 1.4rem;
}
.navigation .guide-book-btn {
  cursor: pointer;
}
.right-side-links {
  font-family: var(--var-IIF-sans-body);
  font-size: 1.1rem;
  margin-right: 0.2rem;
}
.right-side-links a {
  color: white;
  font-weight: bold;
  padding: 0.5rem 1rem;
  text-decoration: none;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.3rem;
  margin-right: 1rem;
}
.right-side-links a:last-child {
  margin: 0;
}
.right-side-links a:hover {
  /* transition: border-color 0.3s; */
  transition: color 0.3s;
  transition: background-color 0.3s;
  color: var(--var-IIF-cyan);
  border-color: var(--var-IIF-cyan);
  background-color: var(--var-IIF-darker-teal);
}

@media (max-width: 576px) {
  .about-long-text {
    display: none;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .feedback-loop-logo {
    top: 0.2rem;
  }
  .navigation h1 {
    margin: 0 0 0 10rem;
    font-size: 1.8rem;
    line-height: 1;
  }

  .right-side-links {
    font-size: 1.4rem;
    margin-right: 2rem;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .feedback-loop-logo {
    height: 5rem;
    position: fixed;
    left: 1rem;
    top: -0.4rem;
    margin: 0;
  }
  .navigation h1 {
    margin: 0 0 0 10rem;
    padding: 0;
    display: inline-block;
    font-size: 2.8rem;
    color: white;
  }
  .navigation h1,
  .navigation h1 a {
    text-decoration: none;
    text-transform: uppercase;
  }
  .navigation h1 .deck-name {
    display: inline;
    font-size: 2.7rem;
  }
  .navigation .created-by {
    display: inline-block;
    margin-left: 1rem;
    font-size: 1.4rem;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>
